// 檢查權限
import store from '@/store/index'
import { UserGettersTypes } from '@/store/modules/user'

// Permissions Item 權限項目
export enum PermissionsItem {
  reconciliations = 'reconciliations',
  branches = 'branches',
  merchants = 'merchants',
  orders = 'orders',
  products = 'products',
  vouchers = 'vouchers',
  any = 'any'
}

// Permissions Action 可執行操作
export enum PermissionsAction {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  any = 'any'
}

export interface PermissionType {
  create: boolean
  read: boolean
  update: boolean
  delete: boolean
}

/**
 * checkPermission
 * @param {string} item - 權限項目
 * @param {string} action - 可執行操作
 * @returns boolean => 有權限:true, 沒有權限:false
 */
export const checkPermission = (item: string, action: string): boolean => {
  const permissions = store.getters[UserGettersTypes.GET_PERMISSION]

  if (permissions[PermissionsItem.any]) {
    // any : any > 所有權限 & 所有動作
    if (permissions[PermissionsItem.any].includes(PermissionsAction.any)) {
      return true
    }
    // any : action > 所有權限 & 指定動作
    if (permissions[PermissionsItem.any].includes(action)) return true
  }

  if (permissions[item]) {
    // item : any > 指定權限 & 所有動作
    if (permissions[item].includes(PermissionsAction.any)) return true
    // item : action > 指定權限 & 指定動作
    if (permissions[item].includes(action)) return true
  }
  return false
}

/**
 * getPermissionByItem
 * @param {string} item - 權限項目
 * @returns obj : 該目錄的 CRUD權限
 */
export const getPermissionByItem = (item: string): PermissionType => {
  const object = {
    [PermissionsAction.create]: checkPermission(item, PermissionsAction.create),
    [PermissionsAction.read]: checkPermission(item, PermissionsAction.read),
    [PermissionsAction.update]: checkPermission(item, PermissionsAction.update),
    [PermissionsAction.delete]: checkPermission(item, PermissionsAction.delete)
  }
  return object
}

/**
 * 檢查權限(authName), 是否每一個權限動作都有
 * @param {string} authName - 權限名稱
 * @param {Array<string>} actions - 權限動作array(可復數)
 * @returns {boolean}
 */
export const getPagePermission = (authName: string, actions: Array<string>): boolean => {
  return actions.map((action: string) => checkPermission(authName, action)).every((item: boolean) => item === true)
}
